import { render, staticRenderFns } from "./AllWorkspaces.vue?vue&type=template&id=47dd2473&"
import script from "./AllWorkspaces.vue?vue&type=script&lang=js&"
export * from "./AllWorkspaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports